module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"compare":{"loose":"Lost","win":"Won","draw":"Draw"},"pending":"Pending..."},"en":{"compare":{"loose":"Lost","win":"Won","draw":"Draw"},"pending":"Pending..."}}')
  delete Component.options._Ctor
}
